import { createAction, props } from '@ngrx/store';
import { Transfer } from '@app/shared/models/transfer';


export const loadTransfersSent = createAction(
  '[TransfersSent] Load Transfers Sent',
);

export const loadTransfersSentSuccess = createAction(
  '[TransfersSent] Load Transfers Sent Success',
  props<{ transfers: Transfer[] }>()
);

export const loadTransfersSentFailure = createAction(
  '[TransfersSent] Load Transfers Sent Failure',
  props<{ error: string }>()
);

export const loadTransfer = createAction(
  '[TransfersSent] Load Transfer',
  props<{ transferId: string }>()
);

export const deleteTransfer = createAction(
  '[TransfersSent] Delete Transfer',
  props<{ transferId: string }>()
);

export const deleteTransferSuccess = createAction(
  '[TransfersSent] Delete Transfer Success',
  props<{ transferId: string }>()
);

export const deleteTransferFailure = createAction(
  '[TransfersSent] Delete Transfer Failure',
  props<{ error: string }>()
);




